<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 11.7487V13C11 13.5523 10.5523 14 10 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H10C10.5523 2 11 2.44772 11 3V4.464"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M5 8L15 8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13 6L15 8L13 10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
